import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const LoginButton: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  return <button className="btn btn-primary btn-lg" onClick={() => loginWithRedirect({
    appState: { returnTo: "/dashboard" }
  })}>Log In</button>;
};

export default LoginButton;
